import { API_COMMON_ERROR } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

export interface UploadAttachmentArgs {
  files: File[];
  endpoint: string;
}

async function uploadMultiAttachments({
  files,
  endpoint,
}: UploadAttachmentArgs): Promise<
  BackResponse<string[]> | BackResponseFailure
> {
  const body = new FormData();

  if (files) {
    files.forEach((file) => {
      body.append('files', file);
    });
  }

  if (
    files &&
    files.some((file) => file.name === 'undefined' || file.name === undefined)
  ) {
    return prepareResponseFailure({
      errors: [{ code: API_COMMON_ERROR.UNHANDLED }],
    });
  }

  try {
    const response = await apiCall<BackResponse<string[]>>(endpoint, {
      method: SUPPORTED_METHODS.POST,
      body,
    });

    if (response.statusCode === 401) {
      return prepareResponseFailure({
        errors: [{ code: API_COMMON_ERROR.UNHANDLED }],
      });
    }

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default uploadMultiAttachments;
